import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';

/**
 * What the profile form may write to a contact method. Consent is a boolean the
 * user sets for themselves; opt-outs only ever come from an inbound STOP, so
 * there is no way to express one here.
 */
export type ContactMethodInput = {
  channel: ContactChannel;
  value: string;
  label?: string | null;
  optedIn?: boolean;
};

export const useUpdateUserProfileSettingsMutation = () => {
  return useMutation({
    mutationFn: async ({
      userId,
      newSettings,
      contactMethods,
    }: {
      userId: string;
      newSettings: any;
      /** Omitted leaves contact methods untouched; an empty array clears them. */
      contactMethods?: ContactMethodInput[];
    }) => {
      return axios.post(config.apiGateway.updateUserProfileSettings, {
        user_id: userId,
        newSettings,
        ...(contactMethods ? { contactMethods } : {}),
      });
    },
  });
};
